
import { DisablableOption } from "@models";
import { DamageType, DataType, DominanceGroupType, DurationType, FeatTier, FeatureType, SizeType, SpellLevel } from "@dndModels/Types";

export const LANGUAGE_TYPES = ["Common","Exotic","Specific","Special"];

export const DICE_SIZES = ["4","6","8","10","12"];
export const DICE_SIZE_OPTIONS: DisablableOption[] = [
  { text: "d4", id: "4" }, 
  { text: "d6", id: "6" },
  { text: "d8", id: "8" }, 
  { text: "d10", id: "10" }, 
  { text: "d12", id: "12" }, 
  { text: "d20", id: "20" }
];
export const ABILITY_SCORES = [
  "STR","DEX","CON","INT","WIS","CHA"
];
export const ABILITY_SCORES_NAMES = [
  "Strength","Dexterity","Constitution","Intelligence","Wisdom","Charisma"
];
export const ABILITY_SCORE_FULL_TO_ABBREV_MAP: any = {
  "Strength": "STR",
  "Dexterity": "DEX",
  "Constitution": "CON",
  "Intelligence": "INT",
  "Wisdom": "WIS",
  "Charisma": "CHA"
};
export const ABILITY_SCORE_ABBREV_TO_FULL_MAP: any = {
  "STR": "Strength",
  "DEX": "Dexterity",
  "CON": "Constitution",
  "INT": "Intelligence",
  "WIS": "Wisdom",
  "CHA": "Charisma"
};
export const ROLL_TYPES = ["Attack","Saving Throw","Ability Check","Skill Check"];
// export const POINTS_FOR_NUM_MAP: { [score: number]: number } = {
//   8: 0,
//   9: 1,
//   10: 2,
//   11: 3,
//   12: 4,
//   13: 5,
//   14: 7,
//   15: 9
// };
export const CHARACTER_LEVELS = ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20"];
export const CHARACTER_LEVEL_NUMS = CHARACTER_LEVELS.map(o => +o);
export const CREATURE_CRS = ["0","0.125","0.25","0.5","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40"];
export const ABILITY_SCORES_EXPANDED = [
  ...ABILITY_SCORES,"Spellcasting","Same as Feat","Selectable","STR or DEX","INT, WIS, or CHA","Your Choice","None"
];
export const DAMAGE_TYPES: DamageType[] = [
  "Bludgeoning", 
  "Piercing", 
  "Slashing", 
  "Acid",
  "Cold",
  "Fire",
  "Force",
  "Lightning",
  "Necrotic",
  "Poison",
  "Psychic",
  "Radiant",
  "Thunder",
  "Typeless",
  "Same as Main"
];
export const EFFECT_TYPES = [
  "None","Control","Summon","Teleport","Portal","Transform","Adaptation",
  "Create Resource","Utility","Create Item","Enhance Item","Enhance Creature","Healing",
  "Max HP","Temp HP","Bonus Roll",
  "Self Condition","Self Gift","Special","Selectable Key",
  "Rollable Table","Draw Card",
  "Damage","Special Feature"
];
export const DRAGON_TYPES = [
  "Metallic",
  "Chromatic",
  "Gem",
  "Warden",
  "Fey",
  "Shadow"
];
export const METALLIC_DRAGONS = [
  "Gold","Silver","Copper","Bronze","Brass"
];
export const CHROMATIC_DRAGONS = [
  "Red","White","Black","Blue","Green"
];
export const GEM_DRAGONS = [
  "Amethyst","Crystal","Emerald","Sapphire","Topaz",
];
export const WARDEN_DRAGONS = [
  "Archon","Knight","Magus","Patron","Rooker",
];
export const ALL_DRAGONS = [...METALLIC_DRAGONS,...CHROMATIC_DRAGONS,...GEM_DRAGONS,...WARDEN_DRAGONS];
export const DRACONIC_DAMAGE_TYPES = {
  Gold: "Fire",
  Silver: "Cold",
  Copper: "Acid",
  Bronze: "Lightning",
  Brass: "Fire",
  Red: "Fire",
  White: "Cold",
  Black: "Acid",
  Blue: "Lightning",
  Green: "Poison",
  Amethyst: "Force",
  Crystal: "Radiant",
  Emerald: "Psychic",
  Sapphire: "Thunder",
  Topaz: "Necrotic",
  Archon: "Fire",
  Knight: "Slashing",
  Magus: "Psychic",
  Patron: "Force",
  Rooker: "Poison"
};
export const DURATIONS: (DurationType | "")[] = [
  "Instantaneous",
  "1 Round",
  "2 Rounds",
  "1 Minute",
  "10 Minutes",
  "1 Hour",
  "8 Hours",
  "24 Hours",
  "Until Dispelled",
  "Special"
];
export const DURATION_NUMBER_MAP = {
  "Instantaneous": 0,
  "1 Round": 1,
  "2 Rounds": 2,
  "1 Minute": 3,
  "10 Minutes": 4,
  "1 Hour": 5,
  "8 Hours": 6,
  "24 Hours": 7,
  "Until Dispelled": 8,
  "Special": -1
};
export const DURATION_OPTIONS: DisablableOption[] = [
  { id: "0", text: "Instantaneous" },
  { id: "1", text: "1 Round" },
  { id: "2", text: "2 Rounds" },
  { id: "3", text: "1 Minute" },
  { id: "4", text: "10 Minutes" },
  { id: "5", text: "1 Hour" },
  { id: "6", text: "8 Hours" },
  { id: "7", text: "24 Hours" },
  { id: "8", text: "Until Dispelled" },
  { id: "-1", text: "Special" },
];
export const COMPONENTS = ["V","S","M"];
export const STANDARD_CASTING_TIMES = [
  "A",
  "BA",
  "RA",
  "Attack",
  "Short Rest",
  "Long Rest",
  "Initiative",
  "Start of Turn",
  "End of Turn",
  "Passive",
  "On Struck",
  "1 Minute",
  "10 Minutes",
  "1 Hour",
  "Special",
];
export const SPELL_CASTING_TIMES = [
  "A",
  "BA",
  "RA",
  "1 Minute",
  "10 Minutes",
  "1 Hour",
  "Special",
];
export const CASTING_TIMES = [
  ...SPELL_CASTING_TIMES,
  "Attack",
  "Light Attack"
];
export const PASSIVE_CASTING_TIMES = [
  "Initiative",
  "Start of Turn",
  "End of Turn",
  "Passive",
  "On Struck",
  "Special"
];
export const CASTING_TIME_MAP = {
  "A": "Action",
  "BA": "Bonus Action",
  "RA": "Reaction",
  "1 Minute": "1 Minute",
  "10 Minutes": "10 Minutes",
  "1 Hour": "1 Hour",
  "Special": "Special",
  "Attack": "Attack",
  "Light Attack": "Light Attack",
  "Ritual Only": "Ritual",
  "Short Rest": "Short Rest",
  "Long Rest": "Long Rest",
  "Initiative": "Initiative",
  "Start of Turn": "Start of Turn",
  "End of Turn": "End of Turn",
  "Passive": "Passive",
  "On Struck": "On Struck"
}
export const CASTING_TIME_OPTIONS: DisablableOption[] = [
  { id: "A", text: "Action" },
  { id: "BA", text: "Bonus Action" },
  { id: "RA", text: "Reaction" },
  { id: "1 Minute", text: "1 Minute" },
  { id: "10 Minutes", text: "10 Minutes" },
  { id: "1 Hour", text: "1 Hour" },
  { id: "Special", text: "Special" },
  { id: "Attack", text: "Attack" },
  { id: "Light Attack", text: "Light Attack" },
  { id: "Ritual Only", text: "Ritual" },
  { id: "Short Rest", text: "Short Rest" },
  { id: "Long Rest", text: "Long Rest" },
  { id: "Initiative", text: "Initiative" },
  { id: "Start of Turn", text: "Start of Turn" },
  { id: "End of Turn", text: "End of Turn" },
  { id: "Passive", text: "Passive" },
  { id: "On Struck", text: "On Struck" },
];
export const SPELL_CASTING_TIME_OPTIONS: DisablableOption[] = [
  { id: "A", text: "Action" },
  { id: "BA", text: "Bonus Action" },
  { id: "RA", text: "Reaction" },
  { id: "1 Minute", text: "1 Minute" },
  { id: "10 Minutes", text: "10 Minutes" },
  { id: "1 Hour", text: "1 Hour" },
  { id: "Special", text: "Special" },
];
export const TARGET_TYPES = ["X Targets","Area","Self","None"];
export const AREA_TYPES = ["Cone","Line","Cube","Square","Sphere","Circle","Cylinder","Wall","None"];
export const RESOURCES = [
  "None", 
  "Channel Divinity",
  "Ki", 
  "Lay on Hands", 
  "Healing Light", 
  "Rage",
  "Slot", 
  "Sorcery Point", 
  "Superiority Dice", 
  "Psionic Energy Dice", 
  "Charge",
  "Special"
];
export const SCHOOLS = [
  "Conjuration",
  "Necromancy",
  "Evocation",
  "Abjuration",
  "Transmutation",
  "Divination",
  "Enchantment",
  "Illusion"
];
export const REFRESH_RULES = [
  "Short Rest",
  "Long Rest",
  "Dawn",
  "1 Hour",
  "2 Hours",
  "8 Hours",
  "24 Hours", 
  "Special",
  "None"
];
export const CHAR_FEATURE_TYPES: FeatureType[] = [
  "Subclass",
  "Subrace",
  "Modifier",
  "Transform Upgrade",
  "Reroll",
  "Spell Modifier",
  "Proficiencies",
  "Expertise",
  "Feat",
  "Selectable",
  "Advantage",
  "Greater Advantage",
  "Damage Multiplier",
  "Resource",
  "Language",
  "Ability Score Improvement",
  "Jack of All Trades",
  "Extra Attacks",
  "Minion Extra Attacks",
  "Ability",
  "Skill as Ability",
  "Skill Ability Override",
  "Minion Ability",
  "Extra Spell as Ability",
  "Item Affecting Ability", // This is for Pact Weapon, Infusions, and Alchemist Potions
  "Item Affecting Ability Type 2", // This is for Pact Weapon, Infusions, and Alchemist Potions
  "Ritual Casting",
  "Spellcasting",
  "Spell Infusions",
  "Spell Infusion Extra Effects",
  "Spellcasting Focus",
  "Spellbook",
  "Spellbook Modifier",
  "Cantrips", // Increases the max known cantrips for a class
  "Spells", // Increases the max known spells for a class
  "Spells from List",
  "Spells from List with Costs",
  "Bonus Spells",
  "Bonus Spells Upgrade",
  "Extra Spell Lists",
  "Eldritch Invocations",
  "Fighting Style",
  "Pact Boon",
  "Proficiency Override",
  "Ignore Heavy Rule",
  "Specific Special Feature",
  "Special Feature",
  "Special Feature Choices",
  "Special Feature List Merge",
  "Mystic Arcanum",
  "Spell Mastery",
  "Sense",
  "Extra IAA Slots",
  "Condition",
  "Alternate Condition",
  "Allowed Conditions",
  "Start Equipment",
  "Unarmed Strikes",
  "Resource Refresh Rule Change",
  "Replace Ability Score for Attacks",
  "Attack Upgrade", // For SS and GWM, etc
  "Versatile Upgrade",
  "Weapon Mastery",
  "Weapon Mastery Master",
  "Extra Effects", // For Sneak Attack, Flame Tongue, etc
  "Extra Effect Type",
  "Extra Effects of Type",
  "Disable Actions",
  "Bonus Action Attack", // For Crossbow Expert, Dual Wielder, etc
  "Weapon Keyword Upgrade",
  "Weapon Keyword Upgrade 2",
  "Weapon Damage Upgrade", // This is used by Monk Martial Arts for upgrading the damage dice used on weapons
  "Characteristic",
  "Minimum Roll", // For Reliable Talent and Silver Tongue
  "Suggested Spells",
  "Special Feat Access", // Gives access to special types of Feats
  "Light Attack Add Damage Mod",
  "Summon Upgrade",
  "Action Type Upgrade",
  "Knowledge",
  "Learnable",
  "Spell Damage Options",
  "Ignore Stealth Disadvantage",
  "Size Options",
  "Limit Spoof",
  "Special Learnable",
  "Rest Alteration",
  "Creature Type" // Changes your Creature Type
];
export const CREATURE_FEATURE_TYPES: FeatureType[] = [
  "Modifier",
  "Reroll",
  "Spell Modifier",
  "Proficiencies",
  "Expertise",
  "Feat",
  "Selectable",
  "Advantage",
  "Greater Advantage",
  "Damage Multiplier",
  "Resource",
  "Language",
  "Ability Score Improvement",
  "Jack of All Trades",
  "Extra Attacks",
  "Minion Extra Attacks",
  "Ability",
  "Skill as Ability",
  "Skill Ability Override",
  "Creature Ability",
  "Condition",
  "Minimum Roll", // For Reliable Talent and Silver Tongue
];
export const TRANSFORM_INTERFACE_FEATURE_TYPES: FeatureType[] = [
  // "Subclass",
  // "Subrace",
  "Modifier",
  "Transform Upgrade",
  "Reroll",
  "Spell Modifier",
  "Proficiencies",
  "Expertise",
  // "Feat",
  "Selectable",
  "Advantage",
  "Greater Advantage",
  "Damage Multiplier",
  // "Resource",
  "Language",
  "Ability Score Improvement",
  "Jack of All Trades",
  "Extra Attacks",
  // "Minion Extra Attacks",
  "Ability",
  "Skill as Ability",
  "Skill Ability Override",
  // "Creature Ability",
  // "Creature Spell as Ability",
  // "Minion Ability",
  // "Extra Spell as Ability",
  // "Item Affecting Ability", // This is for Pact Weapon, Infusions, and Alchemist Potions
  // "Item Affecting Ability Type 2", // This is for Pact Weapon, Infusions, and Alchemist Potions
  "Ritual Casting",
  // "Spellcasting",
  // "Spellcasting Focus",
  // "Spellbook",
  // "Cantrips", // Increases the max known cantrips for a class
  // "Spells", // Increases the max known spells for a class
  // "Spells from List",
  // "Bonus Spells",
  // "Extra Spell Lists",
  // "Eldritch Invocations",
  // "Fighting Style",
  // "Pact Boon",
  // "Specific Special Feature",
  // "Special Feature",
  // "Special Feature Choices",
  // "Special Feature List Merge",
  // "Mystic Arcanum",
  // "Spell Mastery",
  // "Sense",
  // "Extra IAA Slots",
  // "Condition",
  "Allowed Conditions",
  // "Start Equipment",
  "Unarmed Strikes",
  "Resource Refresh Rule Change",
  "Replace Ability Score for Attacks",
  "Attack Upgrade", // For SS and GWM, etc
  "Extra Effects", // For Sneak Attack, Flame Tongue, etc
  "Extra Effect Type",
  "Extra Effects of Type",
  "Disable Actions",
  "Bonus Action Attack", // For Crossbow Expert, Dual Wielder, etc
  "Weapon Keyword Upgrade",
  "Weapon Keyword Upgrade 2",
  "Weapon Damage Upgrade", // This is used by Monk Martial Arts for upgrading the damage dice used on weapons
  "Characteristic",
  "Minimum Roll", // For Reliable Talent and Silver Tongue
  // "Suggested Spells",
  // "Special Feat Access", // Gives access to special types of Feats
  "Light Attack Add Damage Mod",
  // "Summon Upgrade",
  "Action Type Upgrade",
  "Ignore Stealth Disadvantage"
];
export const TRANSFORM_FEATURE_TYPES: FeatureType[] = [
  "Transform Upgrade",
  ...TRANSFORM_INTERFACE_FEATURE_TYPES
];
export const MODIFIER_TARGETS = [
  "AC",
  "Med Armor Max AC from DEX",
  "Max HP",
  "Speed",
  "Ability Check","Skill Check",
  "Saving Throw",
  "Ability Score",
  "Ability Score Max",
  "Spell DC",
  "Attack","Damage","Range",
  "Initiative",
  "Attunement Slots",
  "Table Value",
  "Formula Value",
  "Passive Perception",
  "Passive Insight",
  "Passive Investigation",
  "Size",
  "Size Bonus For Carrying",
  "Carrying Capacity",
  "Max Prepared Spells"
];
export const CREATURE_TYPES = [
  "Humanoid",
  "Beast",
  "Construct",
  "Aberration",
  "Undead",
  "Dragon",
  "Monstrosity",
  "Elemental",
  "Fey",
  "Giant",
  "Ooze",
  "Plant",
  "Shapechanger",
  "Celestial",
  "Fiend"
];
export const ITEM_TYPES = [
  "Armor",
  "Weapon",
  "Ammunition",
  "Artisan's Tools",
  "Gaming Set",
  "Musical Instrument",
  "Potion",
  "Poison",
  "Dust",
  "Ring",
  "Rod",
  "Scroll",
  "Staff",
  "Tool",
  "Vehicle",
  "Wand",
  "Wondrous",
  "Shoe",
  "Cape/Cloak",
  "Gloves",
  "Headgear",
  "Necklace",
  "Belt",
  "Manual",
  "Container",
  "Bracers",
  "Gem",
  "Holy Symbol",
  "Arcane Focus",
  "Druidic Focus",
  "Other",
  "Deck",
  "Card",
  "Book",
  // "Prosthesis"
];
export const TOOL_TYPES = [
  "Artisan's Tools",
  "Gaming Set",
  "Musical Instrument"
];
export const MULTIPLIER_MAP = {
  "Vulnerability": 2,
  "Resistance": 0.5,
  "Immunity": 0,
  "Absorption Half": -0.5,
  "Absorption Whole": -1
};
export const MULTIPLIER_OPTIONS: DisablableOption[] = [
  { text: "Vulnerability", id: "2" },
  { text: "Resistance", id: "0.5" },
  { text: "Immunity", id: "0" },
  { text: "Absorption Half", id: "-0.5" },
  { text: "Absorption Whole", id: "-1" }
];
export const PERCENTAGE_LEVEL_MAP = {
  "Full": 1,
  "Half": (1/2),
  "Third": (1/3),
  "Quarter": (1/4)
};
export const PERCENTAGE_LEVEL_OPTIONS: DisablableOption[] = [
  { text: "Full", id: "1" },
  { text: "Half", id: "1/2" },
  { text: "Third", id: "1/3" },
  { text: "Quarter", id: "1/4" }
];
export const PROFICIENCY_MAP: { [prof_level: number]: string } = {
  0: "Not Proficient",
  0.5: "Half Proficient",
  1: "Proficient",
  2: "Expert"
};
export const ATTACK_TYPES = ["Melee","Ranged","Melee Spell","Ranged Spell","Bonus","Save","Thrown","Light","Versatile"];
export const CLASS_GROUPS = ["Experts","Mages","Priests","Warriors"];
export const RARITIES = [
  "Common",
  "Uncommon",
  "Rare",
  "Very-Rare",
  "Legendary",
  "Artifact",
  "Special"
];
export const RARITY_STR_TO_NUM_MAP: { [rarity: string]: number } = {
  "Common": 0,
  "Uncommon": 1,
  "Rare": 2,
  "Very-Rare": 3,
  "Legendary": 4,
  "Artifact": 5,
  "Special": -1
};
export const RARITY_NUM_TO_STR_MAP: { [rarity: string]: string } = {
  "0": "Common",
  "1": "Uncommon",
  "2": "Rare",
  "3": "Very-Rare",
  "4": "Legendary",
  "5": "Artifact",
  "-1": "Special"
};
export const RARITY_NUM_TO_COLOR_MAP: { [rarity: string]: string } = {
  "0": "inherit",
  "1": "green",
  "2": "blue",
  "3": "purple",
  "4": "orange",
  "5": "brown",
  "-1": "inherit"
};
export const PROFICIENCY_OPTIONS: DisablableOption[] = [
  // { text: "--", id: "-1" },
  { text: "Not Proficient", id: "0" },
  { text: "Half Proficient", id: "0.5" },
  { text: "Proficient", id: "1" },
  { text: "Expert", id: "2" }
];
export const RARITY_OPTIONS: DisablableOption[] = [
  { id: "0", text: "Common" },
  { id: "1", text: "Uncommon" },
  { id: "2", text: "Rare" },
  { id: "3", text: "Very-Rare" },
  { id: "4", text: "Legendary" },
  { id: "5", text: "Artifact" },
  { id: "-1", text: "Special" }
];
export const LEVELED_SPELL_LEVELS = ["1","2","3","4","5","6","7","8","9"];
export const SPELL_LEVELS = ["Cantrip",...LEVELED_SPELL_LEVELS];
export const SPELL_LEVELS_USING_TYPE: SpellLevel[] = [0,1,2,3,4,5,6,7,8,9];
export const SPELL_LEVEL_OPTIONS: DisablableOption[] = [
  { id: "0", text: "Cantrip" },
  { id: "1", text: "1" },
  { id: "2", text: "2" },
  { id: "3", text: "3" },
  { id: "4", text: "4" },
  { id: "5", text: "5" },
  { id: "6", text: "6" },
  { id: "7", text: "7" },
  { id: "8", text: "8" },
  { id: "9", text: "9" }
];
// export const LEVELED_SPELL_LEVEL_OPTIONS: DisablableOption[] = LEVELED_SPELL_LEVELS.map(o => {
//   return { id: o, text: o };
// });
// export const SPELL_LEVEL_OPTIONS: DisablableOption[] = [{ id: "0", text: "Cantrip" },...LEVELED_SPELL_LEVEL_OPTIONS];
export const SLOT_LEVELS = ["Slot: 1","Slot: 2","Slot: 3","Slot: 4","Slot: 5","Slot: 6","Slot: 7","Slot: 8","Slot: 9"];

export const SOURCE_BOOK_TYPES = [
  "Source Book",
  "Setting",
  "Adventure",
  "Homebrew",
  "Unearthed Arcana"
];

export const FEATURE_SOURCE_NAME_TO_TYPE_MAP: any = {
  "Background": "background",
  "Condition": "condition",
  "Eldritch Invocation": "eldritch_invocation",
  "Feat": "feat",
  "Fighting Style": "fighting_style",
  "Class": "game_class",
  "Gift": "gift",
  "Bastion Facility": "bastion_facility",
  "Pact Boon": "pact_boon",
  "Race": "race",
  "Subclass": "subclass",
  "Subrace": "subrace",
  "Item": "item",
  // "Magic Item": "magic_item",
  "Magic Item Keyword": "magic_item_keyword",
  "Organization Position": "org_position"
};

export const FEATURE_SOURCE_TYPE_TO_NAME_MAP: any = {
  "background": "Background",
  "condition": "Condition",
  "eldritch_invocation": "Eldritch Invocation",
  "feat": "Feat",
  "fighting_style": "Fighting Style",
  "game_class": "Class",
  "gift": "Gift",
  "bastion_facility": "Bastion Facility",
  "pact_boon": "Pact Boon",
  "race": "Race",
  "subclass": "Subclass",
  "subrace": "Subrace",
  "item": "Item",
  "magic_item_keyword": "Magic Item Keyword",
  "org_position": "Organization Position",
  "special_feature": "Special Feature",
  "weapon_mastery_property": "Weapon Mastery Property",
};
export const FEATURE_SOURCE_TYPE_TO_PLURAL_NAME_MAP: any = {
  "background": "Backgrounds",
  "condition": "Conditions",
  "eldritch_invocation": "Eldritch Invocations",
  "feat": "Feats",
  "fighting_style": "Fighting Styles",
  "game_class": "Classes",
  "gift": "Gifts",
  "bastion_facility": "Bastion Facilities",
  "pact_boon": "Pact Boons",
  "race": "Races/Species",
  "subclass": "Subclasses",
  "subrace": "Subraces/Lineages",
  "item": "Items",
  // "magic_item": "Magic Items",
  "magic_item_keyword": "Magic Item Keywords",
  "org_position": "Organization Positions",
  "weapon_mastery_property": "Weapon Mastery Properties",
}; 
export const FEATURE_SOURCE_TYPES: DataType[] = [
  "background",
  "condition",
  "eldritch_invocation",
  "feat",
  "fighting_style",
  "game_class",
  "gift",
  "pact_boon",
  "race",
  "subclass",
  "subrace",
  "item",
  "magic_item_keyword",
  "weapon_mastery_property",
  // "org_position",
  "special_feature",
];
export const FEATURE_SOURCE_TYPE_OPTIONS: DisablableOption[] = [
  { id: "background", text: "Background" },
  { id: "condition", text: "Condition" },
  { id: "eldritch_invocation", text: "Eldritch Invocation" },
  { id: "feat", text: "Feat" },
  { id: "fighting_style", text: "Fighting Style" },
  { id: "game_class", text: "Class" },
  { id: "gift", text: "Gift" },
  { id: "bastion_facility", text: "Bastion Facility" },
  { id: "pact_boon", text: "Pact Boon" },
  { id: "race", text: "Race" },
  { id: "subclass", text: "Subclass" },
  { id: "subrace", text: "Subrace" },
  { id: "item", text: "Item" },
  { id: "magic_item_keyword", text: "Magic Item Keyword" },
  { id: "org_position", text: "Org Position" },
  { id: "weapon_mastery_property", text: "Weapon Mastery Property" },
  { id: "special_feature", text: "Special Feature" }
];
export const CHARACTER_LIMITATION_OPTIONS: DisablableOption[] = [
  { id: "game_class", text: "Class" },
  { id: "subclass", text: "Subclass" },
  { id: "class_group", text: "Class Group" },
  { id: "class_or_class_group", text: "Class or Class Group" },
  { id: "race", text: "Race" },
  { id: "subrace", text: "Subrace" },
  { id: "gift", text: "Gift" },
  { id: "feat", text: "Feat" },
  { id: "bastion_facility", text: "Bastion Facility" },
  { id: "alignment", text: "Alignment" },
  { id: "min_ability_score", text: "Minimum Ability Score" }, // Uses min_value, and ids holds the ability score types
  { id: "spellcaster", text: "Spellcaster" }, // 3 options: Spellcasting, Pact Magic, or At least {X} Spell(s)
  { id: "spells_of_schools", text: "Spells from Schools" },
  { id: "spell", text: "Specific Spells" },
  { id: "proficiency", text: "Proficiency" },
  { id: "at_least_1_weapon", text: "Proficiency in at least 1 of this Weapon Type" },
  { id: "at_least_1_language", text: "At least 1 Language known" },
  { id: "level", text: "Char Level" },
  { id: "pact_boon", text: "Pact Boon" },
  { id: "eldritch_invocation", text: "Eldritch Invocation" },
  { id: "tags", text: "Tags" },
  { id: "dragonmark", text: "Dragonmark" },
  { id: "wild_talent", text: "Wild Talent" },
  { id: "feature_of_type", text: "Feature of Type" }
];
export const CHARACTER_LIMITATION_TYPES_SANS_VARIANT_SPECIFIC = [
  "class_group","class_or_class_group","alignment","min_ability_score",
  "spellcaster","spells_of_schools","at_least_1_weapon","at_least_1_language",
  "level","tags","dragonmark","wild_talent","proficiency",""
]

export const SIZE_MAP: { [num: number]: string } = {
  0: "Not Set",
  1: "Tiny",
  2: "Small",
  3: "Medium",
  4: "Large",
  5: "Huge",
  6: "Gargantuan"
}
export const SIZE_TO_NUM_MAP: { [str: string]: SizeType } = {
  "Tiny": 1,
  "Small": 2,
  "Medium": 3,
  "Large": 4,
  "Huge": 5,
  "Gargantuan": 6
}
export const SIZE_OPTIONS: DisablableOption[] = [
  { id: "1", text: "Tiny", disabled: false, reason: "" },
  { id: "2", text: "Small", disabled: false, reason: "" },
  { id: "3", text: "Medium", disabled: false, reason: "" },
  { id: "4", text: "Large", disabled: false, reason: "" },
  { id: "5", text: "Huge", disabled: false, reason: "" },
  { id: "6", text: "Gargantuan", disabled: false, reason: "" }
];

export const TIME_UNIT_MAP: { [num: number]: string } = {
  1: "Turns",
  2: "Rounds",
  3: "Minutes",
  4: "Hours",
  5: "Days",
}
export const TIME_UNIT_MAP_SINGULAR: { [num: number]: string } = {
  1: "Turn",
  2: "Round",
  3: "Minute",
  4: "Hour",
  5: "Day",
}
export const TIME_UNIT_OPTIONS: DisablableOption[] = [
  { id: "1", text: "Turns", disabled: false, reason: "" },
  { id: "2", text: "Rounds", disabled: false, reason: "" },
  { id: "3", text: "Minutes", disabled: false, reason: "" },
  { id: "4", text: "Hours", disabled: false, reason: "" },
  { id: "5", text: "Days", disabled: false, reason: "" },
];

export const COST_UNIT_MAP: { [num: number]: string } = {
  1: "CP",
  2: "SP",
  3: "EP",
  4: "GP",
  5: "PP",
}
export const COST_UNIT_OPTIONS: DisablableOption[] = [
  { id: "1", text: "CP", disabled: false, reason: "" },
  { id: "2", text: "SP", disabled: false, reason: "" },
  { id: "3", text: "EP", disabled: false, reason: "" },
  { id: "4", text: "GP", disabled: false, reason: "" },
  { id: "5", text: "PP", disabled: false, reason: "" },
];

export const SPEED_MAP: { [speed:string]: string } = {
  "walk": "Walking",
  "swim": "Swimming",
  "climb": "Climbing",
  "fly": "Flying",
  "burrow": "Burrowing"
};

export const SPEED_OPTIONS: DisablableOption[] = [
  { id: "walk", text: "Walking", disabled: false, reason: "" },
  { id: "swim", text: "Swimming", disabled: false, reason: "" },
  { id: "climb", text: "Climbing", disabled: false, reason: "" },
  { id: "fly", text: "Flying", disabled: false, reason: "" },
  { id: "burrow", text: "Burrowing", disabled: false, reason: "" },
];

export const PASSIVE_MAP: { [passive:string]: string } = {
  "perception": "Perception",
  "insight": "Insight",
  "investigation": "Investigation"
};

export const PASSIVE_OPTIONS: DisablableOption[] = [
  { id: "perception", text: "Perception", disabled: false, reason: "" },
  { id: "insight", text: "Insight", disabled: false, reason: "" },
  { id: "investigation", text: "Investigation", disabled: false, reason: "" },
];

export const CR_OPTIONS: string[] = [
  "0","0.125","0.25","0.5","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50"
];
export const SIMPLE_CR_OPTIONS: string[] = [
  "0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50"
];

export const FEAT_TIERS: FeatTier[] = ["General","Origin","Epic"]; // These have been moved to tags: ,"Fighting Style","Dragonmark","Wild Talent"
export const DATA_TYPE_INFO: { 
  data_type: DataType, 
  name: string, 
  info?: string,
  plural: string, 
  player_object: boolean, 
  dominance_group: DominanceGroupType, 
  depends_on_data_types?: DataType[],
  extra_fields?: Array<{
    label: string;
    field: string;
    display?: (obj: any) => React.ReactNode;
  }>
}[] = [
  { data_type: "condition", 
    name: "Condition", 
    plural: "Conditions", 
    player_object: false, 
    dominance_group: "Other",
    // extra_fields: [
    //   {
    //     label: "Common",
    //     field: "common"
    //   }
    // ]
  },
  { data_type: "spell", 
    name: "Spell", 
    plural: "Spells", 
    player_object: false, 
    dominance_group: "Spell", 
    depends_on_data_types: ["spell_list"],
    extra_fields: [
      {
        label: "Level",
        field: "level",
        display: (obj: any) => obj.level_string_small
      },
      {
        label: "School",
        field: "school"
      },
      {
        label: "Effect Types",
        field: "effect_types_string"
      },
      {
        label: "Damage Types",
        field: "damage_types_string"
      }
    ]
  },
  { data_type: "spell_list", 
    name: "Spell List", 
    plural: "Spell Lists", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are associated with classes, but sometimes things other than the class itself references a class's spell list, so this provides a way for them to access them. They contain limits of spells. This can be filter parameters, but it's usually just a list of spells. Sometimes this list changes with different source books. That's usually just to add new spells included in that book, but sometimes they will add spells from other books. They can even replace older lists completely, removing access to spells that were on the old list. To account for this we've made it so that the spell limits (including those which are just lists of spells) are associated with specific source books. If a character/campaign isn't using that source book then it won't include the spells from that limit unless they also fit another. These limits can also be marked as Major limits. Only one major limit can be used. The major limit source book which is used for a character or campaign is selectable in the character options controls."
  },
  { data_type: "creature", 
    name: "Creature", 
    plural: "Creatures", 
    player_object: false, 
    dominance_group: "Other",
    extra_fields: [
      {
        label: "Creature Type",
        field: "creature_type"
      },
      {
        label: "CR",
        field: "min_challenge_rating",
        display: (obj: any) => obj.crs_string
      },
      {
        label: "Max HP",
        field: "min_max_hp",
        display: (obj: any) => obj.standard_max_hp
      },
    ],
    depends_on_data_types: ["creature_feature"]
  },
  { data_type: "creature_group", name: "Creature Group", plural: "Creature Groups", player_object: false, dominance_group: "Other" },
  { data_type: "creature_gift", 
    name: "Creature Gift", 
    plural: "Creature Gifts", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are things that can be applied to a creature to give it additional features, such as taking a dragon and turning into a dracolich."
  },
  { data_type: "eldritch_invocation", 
    name: "Eldritch Invocation", 
    plural: "Eldritch Invocations", 
    player_object: false, 
    dominance_group: "Eldritch Invocation",
    // description: "These are for kinds of features where the character gets to choose from one of a few options, and the options are complicated, having various features of their own. This is similar to things such as choosing a subclass, feat, or eldritch invocation, but are less common and more niche. They're generally organized using a Type.",
    // extra_fields: [
    //   {
    //     label: "Type",
    //     field: "special_feature_type"
    //   },
    // ] 
  }, 
  { data_type: "weapon_mastery_property", 
    name: "Weapon Mastery Property", 
    plural: "Weapon Mastery Properties", 
    player_object: false, 
    dominance_group: "Other",
    // description: "These are for kinds of features where the character gets to choose from one of a few options, and the options are complicated, having various features of their own. This is similar to things such as choosing a subclass, feat, or eldritch invocation, but are less common and more niche. They're generally organized using a Type.",
    // extra_fields: [
    //   {
    //     label: "Type",
    //     field: "special_feature_type"
    //   },
    // ]  
  },
  { data_type: "spell_slot_type", 
    name: "Spell Slot Type", 
    plural: "Spell Slot Types", 
    player_object: false, 
    dominance_group: "Other",
    info: "This is how we create different types of spell slots. You're probably familiar with standard Spell Slots and Pact Magic Slots (aka Pact Slots). There are homebrew classes that add other types as well. The main thing that makes them distinct from each other is the progression of how many slots you get and at each level.",
    // extra_fields: [
    //   {
    //     label: "Type",
    //     field: "special_feature_type"
    //   },
    // ]
  },
  { data_type: "fighting_style", name: "Fighting Style", plural: "Fighting Styles", player_object: false, dominance_group: "Other" },
  { data_type: "item", 
    name: "Item", 
    plural: "Items", 
    player_object: false, 
    dominance_group: "Item",
    depends_on_data_types: ["weapon_mastery_property","magic_item_keyword"],
    extra_fields: [
      {
        label: "Item Type",
        field: "item_type"
      },
      {
        label: "Rarity",
        field: "min_rarity",
        display: (obj: any) => obj.rarities_string
      },
    ]   
  },
  { data_type: "magic_item_keyword", 
    name: "Magic Item Keyword", 
    plural: "Magic Item Keywords", 
    player_object: false, 
    dominance_group: "Other",
    depends_on_data_types: [],
    info: "These are things that can be applied to regular items to improve them. Kinda like item enchantments. If you want to make something that is just a specific thing, then you probably want to use Items instead of Magic Item Keywords, but if you want to do something like +1 Weapon, or Dragon Slayer Weapon, or Dragonscale Mail, then this is the right place. You specify a type of item, and sometimes more specific limitations for the kinds of items that it can work with (like the Item Type is Weapon, and then you limit it further to Swords), then on a Character in their inventory they can add the item, and add the keyword to it. There are also some Magic Item Keywords with a rarity of Special. These are for ways to enhance an item through features granted by other things, such as a Warlock's Pact Weapon.",
    extra_fields: [
      {
        label: "Item Type",
        field: "item_types_string"
      },
      {
        label: "Rarity",
        field: "min_rarity",
        display: (obj: any) => obj.rarities_string
      },
    ]
  },
  { data_type: "feat", 
    name: "Feat", 
    plural: "Feats", 
    player_object: false, 
    dominance_group: "Feat",
    extra_fields: [
      {
        label: "Feat Type",
        field: "feat_tier"
      },
      {
        label: "Ability Scores",
        field: "asi_string"
      },
    ]  
  },
  { data_type: "table", 
    name: "Table", 
    plural: "Tables", 
    player_object: false, 
    dominance_group: "Other",
    info: "Classes have a table, showing when they give each feature for characters with that class. For the most part, those features are built into the class, but some parts of a class's table are really just increasing numbers. Those kinds of things are stored here, though more recently we've begun storing them in a part of the class itself. This is more of a legacy of how it was done before, but sometimes things outside the class (usually a subclass feature) might need to reference things from the table. In that case it works better to use this kind of table instead."
  },
  { data_type: "special_feature", 
    name: "Special Feature", 
    plural: "Special Features", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are for kinds of features where the character gets to choose from one of a few options, and the options are complicated, having various features of their own. This is similar to things such as choosing a subclass, feat, or eldritch invocation, but are less common and more niche. They're generally organized using a Type.",
    extra_fields: [
      {
        label: "Type",
        field: "special_feature_type"
      },
    ] 
  },
  { data_type: "gift", 
    name: "Gift", 
    plural: "Gifts", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are similar to feats, but unlike feats, they can't be taken with features that grant feats. They're frequently gained through interacting with powerful magical things.",
    extra_fields: [
      {
        label: "Type",
        field: "gift_type"
      },
    ]  
  },
  { data_type: "bastion_facility", name: "Bastion Facility", plural: "Bastion Facilities", player_object: false, dominance_group: "Other" },
  { data_type: "race", 
    name: "Race/Species", 
    plural: "Races/Species", 
    player_object: false, 
    dominance_group: "Race/Species",
    extra_fields: [
      {
        label: "Creature Type",
        field: "creature_type"
      },
    ] 
  },
  { data_type: "subrace", 
    name: "Subraces/Lineages", 
    plural: "Subraces/Lineages", 
    player_object: false, 
    dominance_group: "Subrace/Lineage", 
    depends_on_data_types: ["race"],
    // description: "",
    extra_fields: [
      {
        label: "Race",
        field: "race_names"
      },
    ] 
  },
  { data_type: "game_class", 
    name: "Class", 
    plural: "Classes", 
    player_object: false, 
    dominance_group: "Class",
    extra_fields: [
      {
        label: "Hit Die",
        field: "hit_die"
      },
      {
        label: "Primary Ability Score",
        field: "primary_abilities_string"
      }
    ] 
  },
  { data_type: "subclass", 
    name: "Subclass", 
    plural: "Subclasses", 
    player_object: false, 
    dominance_group: "Subclass", 
    depends_on_data_types: ["game_class"],
    extra_fields: [
      {
        label: "Class",
        field: "class_name"
      },
    ] 
  },
  { data_type: "background", 
    name: "Background", 
    plural: "Backgrounds", 
    player_object: false, 
    dominance_group: "Background", 
    depends_on_data_types: ["feat"],
    extra_fields: [
      {
        label: "Feat",
        field: "feat_names"
      },
      {
        label: "Ability Scores",
        field: "asi_string"
      }
    ] 
  }, 
  { data_type: "pact_boon", 
    name: "Pact Boon", 
    plural: "Pact Boons", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are the legacy Pact Boons. The new versions are in Eldritch Invocations."
  }, 
  { data_type: "resource", 
    name: "Resource", 
    plural: "Resources", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are for holding resources that are used in multiple places. These are things like Channel Divinity, Ki Points, etc. Spell Slots are similar to resources, but they work significantly differently from regular resources, so they're not kept here. Also not kept here are charges on magic items, rechargable abilities, abilities that say they can be used X times per day, or X times per long rest, etc. Those kinds of things are kept on whatever uses them."
  }, 
  // { data_type: "organization", name: "Organization", plural: "Organizations", player_object: false, dominance_group: "Other" },
  // { data_type: "org_position", name: "Organization Position", plural: "Organization Positions", player_object: false, dominance_group: "Other" },
  // { data_type: "org_instance", name: "Organization Instance", plural: "Organization Instances", player_object: true, dominance_group: "Other" },
  { data_type: "tool", name: "Tool", plural: "Tools", player_object: false, dominance_group: "Other" },
  { data_type: "transform", 
    name: "Transform", 
    plural: "Transforms", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are used in things such as the druid's wild shape as well as polymorph. This functionality is especially complicated, and bugs have been seen. I think they've all been sorted out, but this is currently a one person operation, so be patient. You can use the bug button on the bar at the top to report any bugs you see, and I'll get to them as quickly as I can."
  },
  // { data_type: "adaptation", name: "Adaptation", plural: "Adaptations", player_object: false, dominance_group: "Other" },
  { data_type: "game_card", 
    name: "Game Card", 
    plural: "Game Cards", 
    player_object: false, 
    dominance_group: "Other",
    info: "These are cards in the Deck of Many Things, or something akin to them. The way they're designed to work in the website is that your DM can add a deck in the campaign, and have a high level of control over the cards in it. You may let characters add the deck to their inventory, so they can draw cards themselves, or the DM can draw cards for them using the interface in the campaign page.",
    // extra_fields: [
    //   {
    //     label: "Feat",
    //     field: "feat_names"
    //   },
    //   {
    //     label: "Ability Scores",
    //     field: "asi_string"
    //   }
    // ] 
  },
  { data_type: "game_deck", 
    name: "Game Deck", plural: 
    "Game Decks", 
    player_object: false, 
    dominance_group: "Other",
    info: "This was added for the Deck of Many Things, and things akin to it. The way they're designed to work in the website is that your DM can add a deck in the campaign, and have a high level of control over the cards in it. You may let characters add the deck to their inventory, so they can draw cards themselves, or the DM can draw cards for them using the interface in the campaign page." 
  },
  { data_type: "reusable_string", name: "Reusable String", player_object: false, plural: "Reusable Strings", dominance_group: "Other" },
  { data_type: "campaign", 
    name: "Campaign", 
    plural: "Campaigns", 
    player_object: true, 
    dominance_group: "Other",
    info: "This is for creating and organizing your Campaigns. You can create invitation links and send them to people so they can join and then create characters to be part of the campaign."
  },
  { data_type: "encounter", 
    name: "Encounter", 
    plural: "Encounters", 
    player_object: true, 
    dominance_group: "Other",
    info: "These are for you to create and manage encounters for your players."
  },
  { data_type: "character", 
    name: "Character", 
    plural: "Characters", 
    player_object: true, 
    dominance_group: "Other",
    extra_fields: [
      {
        label: "Race/Species",
        field: "race_string"
      },
      {
        label: "Class(es)",
        field: "class_string"
      },
    ]
  },
  { data_type: "ticket", name: "Ticket", plural: "Tickets", player_object: true, dominance_group: "Other" },
  { data_type: "user_ticket", name: "User Ticket", plural: "User Tickets", player_object: true, dominance_group: "Other" },
  { data_type: "user", name: "User", plural: "Users", player_object: true, dominance_group: "Other" },
  { data_type: "rollable_table", name: "Rollable Table", plural: "Rollable Tables", player_object: false, dominance_group: "Other" },
  { data_type: "floating_feature", name: "Floating Feature", plural: "Features", player_object: false, dominance_group: "Other" },
  { data_type: "creature_feature", name: "Creature Feature", plural: "Creature Features", player_object: false, dominance_group: "Other" },
  { data_type: "source_book", 
    name: "Source Book", 
    plural: "Source Books", 
    player_object: false, 
    dominance_group: "Other",
    extra_fields: [
      {
        label: "Abbreviation",
        field: "abbreviation"
      },
      {
        label: "Type",
        field: "source_book_type"
      },
      {
        label: "3rd Party",
        field: "third_party"
      }
    ]
  },
  { data_type: "deity", 
    name: "Deity", 
    plural: "Deities", 
    player_object: false, 
    dominance_group: "Other",
    extra_fields: [
      {
        label: "Pantheons",
        field: "pantheons"
      },
      {
        label: "Divine Domains",
        field: "divine_domains_string"
      },
      {
        label: "Alignment",
        field: "alignment_string"
      },
    ]   
  },
  { data_type: "equipment_pack", 
    name: "Equipment Pack", 
    plural: "Equipment Packs", 
    player_object: false, 
    dominance_group: "Item",
    info: "These are packs which contain a lot of items."
  },
  { data_type: "standard_features", 
    name: "Standard Features", 
    plural: "Standard Features", 
    player_object: false, 
    dominance_group: "",
    info: "This was added as a way of making some standard game rules work which apply to all characters regardless of any other choices. In the 2024 rulebooks it's stated that characters that have a background that don't give them a feat should be able to choose an origin feat as part of their background. Also if they have a race/species that doesn't give any ability score increases and a background that also doesn't give any ability score increases they should be able to choose some (either +2 and +1, or three +1s), and characters that don't have languages through their race/species and also don't have languages through their background should get Common and 2 other languages of their choice."
  },
  { data_type: "optional_feature_base", 
    name: "Optional Feature", 
    plural: "Optional Features", 
    player_object: false, 
    dominance_group: "",
  },
  { data_type: "template", 
    name: "Template", 
    plural: "Templates", 
    player_object: false, 
    dominance_group: "",
  },
];


export const DATA_TYPE_OPTIONS: DisablableOption[] = [
  { id: "condition", text: "Condition" },
  { id: "spell", text: "Spell" },
  { id: "creature", text: "Creature" },
  { id: "weapon_keyword", text: "Weapon Keyword" },
  { id: "armor_type", text: "Armor Type" },
  { id: "item", text: "Item" },
  { id: "magic_item_keyword", text: "Magic Item Keyword" },
  { id: "feat", text: "Feat" },
  { id: "table", text: "Table" },
  { id: "special_feature", text: "Special Feature" },
  { id: "gift", text: "Gift" },
  { id: "race", text: "Race/Species" },
  { id: "subrace", text: "Subrace/Lineage" },
  { id: "background", text: "Background" }, 
  { id: "proficiency", text: "Proficiency" }, 
  { id: "resource", text: "Resource" }, 
  { id: "sense", text: "Sense" },
  { id: "tool", text: "Tool" },
  { id: "transform", text: "Transform" },
  { id: "summon", text: "Summon" },
  { id: "adaptation", text: "Adaptation"},
  { id: "deity", text: "Deity"},
];

export const CORE_DATA_TYPES = [
  "source_book",
  "reusable_string",
  "floating_feature",
  "optional_feature_base",
  "special_feature",
  // "game_class",
  // "subclass",
  "table",
  "spell_list",
  // "item",
  "magic_item_keyword",
  // "spell",
  // "race",
  // "subrace",
  // "background",
  // "resource",
  "condition",
  // "feat",
  // "gift",
  // "pact_boon",
  // "eldritch_invocation",
  // "transform",
  // "creature",
  "tool",
];
export const SELECTABLE_TYPES = [
  "Ability Score",
  "Damage Type",
  "School of Magic",
  "Dragon Type", // Metallic, Chromatic, Gem
  "Dragon Breed", // Metal, Color, Gem
  "Strings",
  "Spell List",
  "Race",
  "Item",
  "Weapon Type",
  "Spell",
  "Character Spell",
  "Number",
  "Dice Size"
];
export const AMMUNITION_TYPES = ["Arrow","Crossbow Bolt","Sling Bullet","Bullet","Stone","Needle","Special","Ōdzutsu Shot","None"];
export const WEAPON_TYPES = [
  "Battleaxe","Blowgun","Club","Crossbow, Hand",
  "Crossbow, Heavy","Crossbow, Light","Dagger",
  "Dart","Flail","Glaive",
  "Greataxe","Greatclub","Greatsword",
  "Halberd","Handaxe","Javelin","Lance",
  "Light Hammer","Longbow","Longsword",
  "Mace","Maul","Morningstar","Pike","Quarterstaff",
  "Rapier","Scimitar","Shortbow","Shortsword",
  "Sickle","Sling","Spear","Trident",
  "War Pick","Warhammer","Whip","None"
];
export const BOOK_TYPES = ["Spell","Creature","Item","Other"];

export const RECIPE_COMPONENT_TYPES = ["Animus","Ash","Fluid","Organ","Hair","Bone","Hide","Natural Weapon","Trophy","Other","None"];

export const CHALLENGE_RATINGS: DisablableOption[] = [
  { id: "0", text: "0" },
  { id: "0.125", text: "1/8" },
  { id: "0.25", text: "1/4" },
  { id: "0.5", text: "1/2" },
];
for (let i = 1; i < 50; ++i) {
  CHALLENGE_RATINGS.push({ id: `${i}`, text: `${i}` });
}
export const XP_FOR_CR: { [cr_str: string]: number } = {
  "0":      10,
  "0.125":  25,
  "0.25":   50,
  "0.5":    100,
  "1/8":    25,
  "1/4":    50,
  "1/2":    100,
  "1":	    200,
  "2":      450,
  "3":      700,
  "4":      1100,
  "5":      1800,
  "6":      2300,
  "7":      2900,
  "8":      3900,
  "9":      5000,
  "10":     5900,
  "11":     7200,
  "12":     8400,
  "13":     10000,
  "14":     11500,
  "15":     13000,
  "16":     15000,
  "17":     18000,
  "18":     20000,
  "19":     22000,
  "20":     25000,
  "21":     33000,
  "22":     41000,
  "23":     50000,
  "24":     62000,
  "25":     75000,
  "26":     90000,
  "27":     105000,
  "28":     120000,
  "29":     135000,
  "30":     155000,
}

export const HIT_DICE_SIZE_MAP: { [size: number]: number } = {
  1: 4,
  2: 6,
  3: 8,
  4: 10,
  5: 12,
  6: 20
}

export const CREATURE_ALIGNMENTS = [
  "Lawful Good",
  "Lawful Neutral",
  "Lawful Evil",
  "Neutral Good",
  "Neutral",
  "Neutral Evil",
  "Chaotic Good",
  "Chaotic Neutral",
  "Chaotic Evil",
  "Typically Lawful Good",
  "Typically Lawful Neutral",
  "Typically Lawful Evil",
  "Typically Neutral Good",
  "Typically Neutral",
  "Typically Neutral Evil",
  "Typically Chaotic Good",
  "Typically Chaotic Neutral",
  "Typically Chaotic Evil",
  "Any Alignment",
  "Any Chaotic Alignment",
  "Any Evil Alignment",
  "Any Non-good Alignment",
  "Any Non-lawful Alignment",
  "Unaligned",
  "Neutral Good (50%) Or Neutral Evil (50%)"
]

export const TIME_RESTRICTIONS = ["Every Time","1/Turn","Once on Your Turn","Bonus Action","Hide","Special"];
export const HAPPENS_WHEN = ["On a Hit","On a Miss","On a Failed Save","On a Succeeded Save","On Attack","On Use","Special"];

export const CHARACTER_PIECES = ["abilities","features","hp","spells","items","race","gifts","classes","background","bastion_facilities"]; // ,"orgs"

export const SPELLCASTING_FOCUSES = ["Arcane Focus","Holy Symbol","Druidic Focus","Artisan's Tools","Musical Instrument","Spellbook"];

export const EXTRA_BASE_TYPES = [
  "None",
  "Ability Score",
  "Damage Type",
  "School of Magic",
  "Dragon Type", // Metallic, Chromatic, Gem
  "Dragon Breed", // Metal, Color, Gem
  "Creature Type",
  "Strings",
  "Spell List",
  "Spell"
];

export const PALETTE = {
  mode: "dark",
  primary: {
    light: "#FFFFFF",
    main: "#5F9EA0",
    dark: "#2F4F4F", 
    // contrastText: "#5F9EA0"
  }, 
  secondary: {
    light: "#5F9EA0",
    main: "rgba(28, 54, 35, 0.8)", // "#1c3623",
    dark: "#105422", 
    // contrastText: "#5F9EA0"
  }, 
  attack: {
    light: "#FFFFFF",
    main: "rgba(106, 3, 29, 0.8)", 
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  ability: {
    light: "#FFFFFF",
    main: "rgba(93, 61, 39, 0.8)",
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  item: {
    light: "#FFFFFF",
    main: "rgba(105, 102, 100, 0.8)",
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  movement: {
    light: "#FFFFFF",
    main: "rgba(195, 192, 190, 0.8)",
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  // reaction: {
  //   light: "#FFFFFF",
  //   main: "rgba(28, 54, 35, 0.8)", // "#1c3623",
  //   dark: "#105422", 
  // }, 
  game_background: {
    light: "#FFFFFF",
    main: "rgba(66, 46, 9, 0.8)", 
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  race: {
    light: "#FFFFFF",
    main: "rgba(94, 9, 30, 0.8)", 
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  subrace: {
    light: "#FFFFFF",
    main: "rgba(104, 6, 73, 0.8)", 
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  subclass: {
    light: "#FFFFFF",
    main: "rgba(61, 3, 106, 0.8)", 
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  feat: {
    light: "#FFFFFF",
    main: "rgba(3, 106, 97, 0.8)", 
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  gift: {
    light: "#FFFFFF",
    main: "rgba(12, 3, 106, 0.8)", 
    dark: "#105422", 
    contrastText: "#5F9EA0"
  }, 
  magic_types: {
    arcane: {
      light: "#FFFFFF",
      main: "rgba(51, 45, 157, 0.8)", // "#1c3623",
      dark: "#105422", 
      contrastText: "#5F9EA0"
    }, 
    divine: {
      light: "#FFFFFF",
      main: "rgba(208, 210, 60, 0.8)", // "#1c3623",
      dark: "#105422", 
      contrastText: "black"
    }, 
    eldritch: {
      light: "#FFFFFF",
      main: "rgba(99, 41, 108, 0.8)", // "#1c3623",
      dark: "#105422", 
      contrastText: "#5F9EA0"
    }, 
    primal: {
      light: "#FFFFFF",
      main: "rgba(32, 99, 50, 0.8)", // "#1c3623",
      dark: "#105422", 
      contrastText: "#5F9EA0"
    }, 
    other: {
      light: "#FFFFFF",
      main: "rgba(69, 70, 69, 0.8)", // "#1c3623",
      dark: "#105422", 
      contrastText: "#5F9EA0"
    }, 
  }
};

export const WORLD_SETTINGS = [
  "Forgotten Realms", 
  "Eberron", 
  "Dragonlance", 
  "Ravenloft", 
  "Spelljammer", 
  "Drakkenheim", 
  "Dark Sun", 
  "Planescape",
];

export const BASTION_FACILITY_SIZES = ["Cramped","Roomy","Vast"];
export const BASTION_FACILITY_SIZE_OPTIONS: DisablableOption[] = [
  { id: "Cramped", text: "Cramped (4 Squares)" },
  { id: "Roomy", text: "Roomy (16 Squares)" },
  { id: "Vast", text: "Vast (36 Squares)" }
];
export const TICKET_TYPES = ["Bug", "Suggestion", "Comment"];
